import styled from 'styled-components';

export const ExportButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 15px;
  font-family: 'Poppins', sans-serif;
  border-radius: 4px;
  text-align: center;
  min-width: 120px;
  height: 34px;
  padding: 0 12px;
  color: #007ade;
  border: 1px solid #509ee5;
  transition: all 0.3s ease-in;
  background-color: white;
  cursor: pointer;
  &:hover,
  &.active {
    color: white;
    background-color: #007ade;
    border: 1px solid #007ade;
  }
  &:disabled {
    pointer-events: all;
    cursor: not-allowed;
    color: grey;
    border-color: grey;
    background-color: transparent;
  }
`;
